import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const API = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

// Attach token to requests automatically
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const loginApi = (email, password) =>
  API.post("auth/login", { email, password });

export const sendOtpApi = (email, action) =>
  API.post("auth/send-otp", { email, action });

export const forgotPasswordApi = (email) =>
  API.post("auth/forgot-password", { email });

export const resetPasswordApi = (otp,new_password,confirm_password) =>
  API.post("auth/reset-password", { otp,new_password,confirm_password });
export const verifyOtpApi = (email, otp) =>
  API.post("auth/verify-otp", { email, otp });

export const fetchUserApi = () => API.get("auth/me");

export const refreshTokenApi = (refreshToken) =>
  API.post("auth/refresh", { refreshToken });

export const logoutApi = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
};

// export const downloadFileApi = (entity_ids) =>
//   API.post("admin/directories/download-files", 
//     { entity_ids }, 
//     { responseType: "blob" } // ✅ Ensure response is treated as a file
//   );

export const downloadFileApi = (entity_ids, path) =>
    API.post(`${path}/download-files`,
      { entity_ids }, 
      { responseType: "blob" } // ✅ Ensure response is treated as a file
    );

// Generate secure one-time file access token
export const generateFileTokenApi = (filePath, isDownload = false) =>
  API.post("admin/generate-file-token", { filePath, isDownload });

// For client users
export const generateClientFileTokenApi = (filePath, isDownload = false) =>
  API.post("client/generate-file-token", { filePath, isDownload });
